import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import store from "../../../store";
import { setMetaEntityList } from "../../../features/metaEntitiesSlice";
import { metaEntitiesService } from "../../../services/api/meta-entities.endpoints";

//trafficSource
async function getMetaTrafficSource(oauthTokenHeader: any, setMetaTrafficSource: any,trackPromise:any) {
    try{
        const response = await metaEntitiesService.getMetaTrafficSource(oauthTokenHeader);
        if(!response.status || response.status !== 200){
            trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Traffic Source', type: 'error' })));
        }else {
            setMetaTrafficSource(response?.data?.data);
            // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Traffic Source Have Been Created Successfully', type: 'success' })));
        }
    }catch(e:any) {
        trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' })));
    }
}

//Duplicate Traffic Source get API with implemented redux functionality, because it is manupulating other module (Page-Group) (might be deleted in future)
async function getMetaTrafficSourceDuplicate(oauthTokenHeader: any, dispatch: any) {
    try{
        const response = await metaEntitiesService.getMetaTrafficSource(oauthTokenHeader);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Traffic Source', type: 'error' }))
        }else {
            dispatch(setMetaEntityList(response?.data?.data));
            // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Traffic Source Have Been Created Successfully', type: 'success' })));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function createMetaTrafficSource(oauthTokenHeader: string, data: any) {
    try{
        const response = await metaEntitiesService.createMetaTrafficSource(oauthTokenHeader, data);
        if(!response.status || response.status !== 201){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Creating Meta Traffic Source', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Traffic Source Have Been Created Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));             
    }
}

async function updateMetaTrafficSource(oauthTokenHeader: string, data: any, sourceShareuid:any) {
    try{
        const response = await metaEntitiesService.updateMetaTrafficSource(oauthTokenHeader, data, sourceShareuid);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Updating Meta Traffic Source', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Traffic Source Have Been Updated Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));             
    }
}

//device type

async function getMetaDeviceType(oauthTokenHeader: string, dispatch: any) {
    try{
        const response = await metaEntitiesService.getMetaDevices(oauthTokenHeader);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Device Type', type: 'error' }))
        }else {
            dispatch(setMetaEntityList(response?.data?.data));
            // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Device Type Have Been Created Successfully', type: 'success' })));
        }
    }catch(e:any) {
       store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function createMetadeviceType(oauthTokenHeader: string, data: any) {
    try{
        const response = await metaEntitiesService.createMetaDeviceType(oauthTokenHeader, data);
        if(!response.status || response.status !==201){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Creating Meta Device Type', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta device Type Have Been Created Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));  
    }
}

async function updateMetaDeviceType(oauthTokenHeader: string, data: any, sourceShareuid:any) {
    try{
        const response = await metaEntitiesService.updateMetaDeviceType(oauthTokenHeader, data, sourceShareuid);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Updating Meta Device Type', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Device Type Have Been Updated Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));             
    }
}

//product type

async function getMetaProductType(oauthTokenHeader: string, dispatch: any) {
    try{
        const response = await metaEntitiesService.getMetaProductTypes(oauthTokenHeader);
        if(!response.status || response.status !==200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Product Type', type: 'error' }))
        }else {
            dispatch(setMetaEntityList(response?.data?.data));
            // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Product Type Have Been Created Successfully', type: 'success' })));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function createMetaProductType(oauthTokenHeader: string, data: any) {
    try{
        const response = await metaEntitiesService.createMetaProductTypes(oauthTokenHeader, data);
        if(!response.status || response.status !==201){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Creating Meta Product Type', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Product Type Have Been Created Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

async function updateMetaProductType(oauthTokenHeader: string, data: any, sourceShareuid:any) {
    try{
        const response = await metaEntitiesService.updateMetaProductTypes(oauthTokenHeader, data, sourceShareuid);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Updating Meta Product Type', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Product Type Have Been Updated Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));             
    }
}


// industry

async function getMetaIndustry(oauthTokenHeader: string, dispatch:any) {
    try{
        const response = await metaEntitiesService.getMetaIndustries(oauthTokenHeader);
        if(!response.status || response.status !==200){
          store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Industry', type: 'error' }))
        }else {
            dispatch(setMetaEntityList(response?.data?.data));
            // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Industry Type Have Been Created Successfully', type: 'success' })));
        }
    }catch(e:any) {
      store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function createMetaIndustry(oauthTokenHeader: string, data: any) {
    try{
        const response = await metaEntitiesService.createMetaIndustries(oauthTokenHeader, data);
        if(!response.status || response.status !==201){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Creating Meta Industry', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Industry Have Been Created Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));  
    }
}

async function updateMetaIndustry(oauthTokenHeader: string, data: any, sourceShareuid:any) {
    try{
        const response = await metaEntitiesService.updateMetaIndustries(oauthTokenHeader, data, sourceShareuid);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Updating Meta Industry', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Industry Have Been Updated Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

// currency type

async function getMetaCurrencyType(oauthTokenHeader: string, dispatch:any) {
    try{
        const response = await metaEntitiesService.getMetaCurrencies(oauthTokenHeader);
        if(!response.status || response.status !==200){
          store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Currency Type', type: 'error' }))
        }else {
            dispatch(setMetaEntityList(response?.data?.data));
            // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Currency Type Have Been Created Successfully', type: 'success' })));
        }
    }catch(e:any) {
       store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' })) 
    }
}

async function createMetaCurrencyType(oauthTokenHeader: string, data: any) {
    try{
        const response = await metaEntitiesService.createMetaCurrencies(oauthTokenHeader, data);
        if(!response.status || response.status !==201){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Creating Meta Currency Type', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Currency Type Have Been Created Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));  
    }
}

async function updateMetaCurrencyType(oauthTokenHeader: string, data: any, sourceShareuid:any) {
    try{
        const response = await metaEntitiesService.updateMetaCurrencies(oauthTokenHeader, data, sourceShareuid);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Updating Meta Currency Type', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Currency Type Have Been Updated Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

//Traffic Click Identifiers

async function getMetaTrafficClickIdentifiers(oauthTokenHeader: string, dispatch: any) {
    try{
        const response = await metaEntitiesService.getMetaTrafficClickIdentifiers(oauthTokenHeader);
        if(!response.status || response.status !==200){
           store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Traffic Source', type: 'error' }));
        }else {
            dispatch(setMetaEntityList(response?.data?.data));
            // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Traffic Source Have Been Created Successfully', type: 'success' })));
        }
    }catch(e:any) {
       store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))  
    }
}

async function createMetaTrafficClickIdentifiers(oauthTokenHeader: string, data: any) {
    try{
        const response = await metaEntitiesService.createMetaTrafficClickIdentifiers(oauthTokenHeader, data);
        if(!response.status || response.status !==201){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Creating Meta Traffic Source', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Traffic Source Have Been Created Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));  
    }
}

async function updateMetaTrafficClickIdentifiers(oauthTokenHeader: string, data: any, sourceShareuid:any) {
    try{
        const response = await metaEntitiesService.updateMetaTrafficClickIdentifiers(oauthTokenHeader, data, sourceShareuid);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Updating Meta Traffic Source', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Traffic Source Have Been Updated Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

//Territory

async function getMetaTerritory(oauthTokenHeader: string, dispatch: any) {
    try{
        const response = await metaEntitiesService.getMetaTerritories(oauthTokenHeader);
        if(!response.status || response.status !==200){
         store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Territory', type: 'error' }))
        }else {
            dispatch(setMetaEntityList(response?.data?.data));
            // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Territory Have Been Created Successfully', type: 'success' })));
        }
    }catch(e:any) {
       store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function createMetaTerritory(oauthTokenHeader: string, data: any) {
    try{
        const response = await metaEntitiesService.createMetaTerritories(oauthTokenHeader, data);
        if(!response.status || response.status !==201){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Creating Meta Territory', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Territory Have Been Created Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
        }
}

async function updateMetaTerritory(oauthTokenHeader: string, data: any, sourceShareuid:any) {
    try{
        const response = await metaEntitiesService.updateMetaTerritories(oauthTokenHeader, data, sourceShareuid);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Updating Meta Territory', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Territory Have Been Updated Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

// Organizations

async function getMetaOrganizations(oauthTokenHeader: string,dispatch:any) {
    try {
        const response = await metaEntitiesService.getMetaOrganizations(oauthTokenHeader);
        if(!response.status || response.status !==200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Territory', type: 'error' }))
        }else {
            dispatch(setMetaEntityList(response?.data?.data));
        }
    } catch (e:any) {
       store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function createMetaOrganizations(oauthTokenHeader: string, data: any) {
    try{
        const response = await metaEntitiesService.createMetaOrganizations(oauthTokenHeader, data);
        if(!response.status || response.status !==201){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Creating Meta Territory', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Territory Have Been Created Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
        }
}

async function updateMetaOrganizations(oauthTokenHeader: string, data: any, sourceShareuid:any) {
    try{
        const response = await metaEntitiesService.updateMetaOrganizations(oauthTokenHeader, data, sourceShareuid);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Updating Meta Territory', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Territory Have Been Updated Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

// Geo

async function getMetaGeo(oauthTokenHeader: string, setMetaGeo: any,trackPromise:any) {
    try {
        const response = await metaEntitiesService.getMetaGeo(oauthTokenHeader);
        if(!response.status || response.status !== 200){
            trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Territory', type: 'error' })));
        }else {
            setMetaGeo(response?.data?.data); 
        }
    } catch (e:any) {
        trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' })));
    }
}

//Duplicate Geo get API with implemented redux functionality, because it is manupulating other module (Website-Actions) (might be deleted in future)

async function getMetaGeoDuplicate(oauthTokenHeader: string, dispatch: any) {
    try {
        const response = await metaEntitiesService.getMetaGeo(oauthTokenHeader);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Territory', type: 'error' }))
        }else {
            dispatch(setMetaEntityList(response?.data?.data));
        }
    } catch (e:any) {
       store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
    }
}

async function createMetaGeo(oauthTokenHeader: string, data: any) {
    try{
        const response = await metaEntitiesService.createMetaGeo(oauthTokenHeader, data);
        if(!response.status || response.status !== 201){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Creating Meta Territory', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Territory Have Been Created Successfully', type: 'success' }));
        }
    } catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

async function updateMetaGeo(oauthTokenHeader: string, data: any, sourceShareuid:any) {
    try{
        const response = await metaEntitiesService.updateMetaGeo(oauthTokenHeader, data, sourceShareuid);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Updating Meta Territory', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Territory Have Been Updated Successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

async function getTerritory( setAdAccountTerritoryDetails:any, oauthTokenHeader: string ) {
    try {
        const response = await metaEntitiesService.getTerritories(oauthTokenHeader)
        if (!response.status || response.status !== 200){
        store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' }));
        } else {
            setAdAccountTerritoryDetails(response?.data?.data)
        }
    } catch (e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}


//-- Get Meta Format Types
async function getMetaFormatTypes(oauthTokenHeader: string, dispatch: any) {
    try{
        const response = await metaEntitiesService.getMetaFormatTypes(oauthTokenHeader);
        if(!response.status || response.status !==200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Format Types', type: 'error' }));
        }else {
            dispatch(setMetaEntityList(response?.data?.data));
            // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Product Type Have Been Created Successfully', type: 'success' })));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

// -- Create Meta Format Type
async function createMetaFormatType(oauthTokenHeader: string, data: any) {
    try{
        const response = await metaEntitiesService.createMetaFormatTypes(oauthTokenHeader, data);
        if(!response.status || response.status !==201){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while creating meta format type', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta format types has been created successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

// -- Edit Meta Format Type
async function updateMetaFormatType(oauthTokenHeader: string, data: any, formatShareuid:any) {
    try{
        const response = await metaEntitiesService.updateMetaFormatTypes(oauthTokenHeader, data, formatShareuid);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while updating meta format Type', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta format types has been updated successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));             
    }
}

//-- Get Meta Collection Methods
async function getMetaCollectionMethods(oauthTokenHeader: string, dispatch: any) {
    try{
        const response = await metaEntitiesService.getMetaCollectionMethods(oauthTokenHeader);
        if(!response.status || response.status !==200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Collection Methods', type: 'error' }));
        }else {
            dispatch(setMetaEntityList(response?.data?.data));
            // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Product Type Have Been Created Successfully', type: 'success' })));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

// -- Create Meta Collection Methods
async function createMetaCollectionMethod(oauthTokenHeader: string, data: any) {
    try{
        const response = await metaEntitiesService.createMetaCollectionMethods(oauthTokenHeader, data);
        if(!response.status || response.status !==201){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while creating meta collection methods', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta collection methods has been created successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

// -- Edit Meta Format Type
async function updateMetaCollectionMethod(oauthTokenHeader: string, data: any, collectionShareuid:any) {
    try{
        const response = await metaEntitiesService.updateMetaCollectionMethods(oauthTokenHeader, data, collectionShareuid);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while updating meta collection methods', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta collection methods has been updated successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));             
    }
}

//-- Get Meta Collection Types
async function getMetaCollectionType(oauthTokenHeader: string, dispatch: any) {
    try{
        const response = await metaEntitiesService.getMetaCollectionTypes(oauthTokenHeader);
        if(!response.status || response.status !==200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Meta Collection Types', type: 'error' }));
        }else {
            dispatch(setMetaEntityList(response?.data?.data));
            // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Meta Product Type Have Been Created Successfully', type: 'success' })));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

// -- Create Meta Collection Types
async function createMetaCollectionType(oauthTokenHeader: string, data: any) {
    try{
        const response = await metaEntitiesService.createMetaCollectionTypes(oauthTokenHeader, data);
        if(!response.status || response.status !==201){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while creating meta collection types', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta collection types has been created successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    }
}

// -- Edit Meta Collection Type
async function updateMetaCollectionType(oauthTokenHeader: string, data: any, collectionTypeShareuid:any) {
    try{
        const response = await metaEntitiesService.updateMetaCollectionTypes(oauthTokenHeader, data, collectionTypeShareuid);
        if(!response.status || response.status !== 200){
            store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while updating meta collection types', type: 'error' }));
        }else {
            store.dispatch(setDisplayErrorSnackBar({ message: 'Meta collection types has been updated successfully', type: 'success' }));
        }
    }catch(e:any) {
        store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));             
    }
}

export const MetaEntitiesEndPointLogic = {
    getMetaCollectionType,
    createMetaCollectionType,
    updateMetaCollectionType,
    getMetaCollectionMethods,
    createMetaCollectionMethod,
    updateMetaCollectionMethod,
    getMetaTrafficSource,
    createMetaTrafficSource,
    updateMetaTrafficSource,
    getMetaDeviceType,
    createMetadeviceType,
    updateMetaDeviceType,
    getMetaProductType,
    createMetaProductType,
    updateMetaProductType,
    getMetaIndustry,
    createMetaIndustry,
    updateMetaIndustry,
    getMetaCurrencyType,
    createMetaCurrencyType,
    updateMetaCurrencyType,
    getMetaTrafficClickIdentifiers,
    createMetaTrafficClickIdentifiers,
    updateMetaTrafficClickIdentifiers,
    getMetaTerritory,
    createMetaTerritory,
    updateMetaTerritory,
    getMetaOrganizations,
    createMetaOrganizations,
    updateMetaOrganizations,
    getMetaGeo,
    createMetaGeo,
    updateMetaGeo,
    getTerritory,
    getMetaFormatTypes,
    createMetaFormatType,
    updateMetaFormatType,
    getMetaTrafficSourceDuplicate,
    getMetaGeoDuplicate
}
